export default "__VITE_ASSET__qRHU078___"